import { Pipe, PipeTransform } from '@angular/core';
import { toWords } from 'number-to-words';

@Pipe({
    name: 'numberToWord',
})
export class NumberToWordPipe implements PipeTransform {
    transform(value: number): string {
        return toWords(value);
    }
}
